import { alpha } from '@mui/material';

import { primary, violet } from '~styles/colors';

export const secondaryGradient = {
  100: `linear-gradient(45deg, ${alpha(violet['100'], 1)}, ${alpha(
    primary['100'],
    1
  )})`,
  75: `linear-gradient(45deg, ${alpha(violet['100'], 0.75)}, ${alpha(
    primary['100'],
    0.75
  )})`,
  50: `linear-gradient(45deg, ${alpha(violet['100'], 0.5)}, ${alpha(
    primary['100'],
    0.5
  )})`,
  25: `linear-gradient(45deg, ${alpha(violet['100'], 0.25)}, ${alpha(
    primary['100'],
    0.25
  )})`,
  10: `linear-gradient(45deg, ${alpha(violet['100'], 0.1)}, ${alpha(
    primary['100'],
    0.1
  )})`,
};

export type SecondaryGradientVariants = keyof typeof secondaryGradient;
